<template>
	<div
		:class="{ ended }"
		class="alarm-item"
	>
		<div class="description">{{ description }}</div>
		<CountDown
			ref="countdown"
			:time="timeLeft"
			:interval="1000"
			:leading-zero="true"
			class="time-left"
			tag="div"
			@countdownend="countdownend"
			@countdownprogress="tick"
		>
			<template slot-scope="props">
				{{ props.totalHours }}:{{ props.minutes }}:{{ props.seconds }}
			</template>
		</CountDown>
	</div>
</template>

<script>
import * as R from 'ramda';
import CountDown from '@xkeshi/vue-countdown';
import Beeper from './Beeper';

export default {
	name: 'AlarmItem',
	components: {
		CountDown,
	},
	props: {
		description: {
			type: String,
			default: () => '',
		},
		time: {
			type: Number,
			default: () => 0,
		},
		paused: {
			type: Boolean,
			default: () => false,
		},
		timeLeft: {
			type: Number,
			default: () => 0,
		},
	},
	data() {
		return {
			ended: false,
			beeper: Beeper(),
		};
	},
	watch: {
		paused(paused) {
			if (paused) {
				this.$refs.countdown.pause();
			} else {
				this.$refs.countdown.start();
			}
		},
	},
	methods: {
		countdownend() {
			if (this.ended) {
				return;
			}
			this.sound();
			this.$emit('done');
			this.ended = true;
		},
		tick(data) {
			const time = R.pipe(
				R.evolve({
					days: R.multiply(86400000),
					hours: R.multiply(3600000),
					minutes: R.multiply(60000),
					seconds: R.multiply(1000),
				}),
				R.values,
				R.sum,
			)(data);
			this.$emit('timeLeft', time);
		},
		sound() {
			this.beeper.play(440);
		},
	},
};
</script>

<style lang="stylus" scoped>
.alarm-item
	display flex
	justify-content space-between
	align-items center
</style>



// WEBPACK FOOTER //
// src/components/AlarmItem.vue